import { render, staticRenderFns } from "./acctInfoPwdModify.vue?vue&type=template&id=21b28965&scoped=true"
import script from "./acctInfoPwdModify.vue?vue&type=script&lang=js"
export * from "./acctInfoPwdModify.vue?vue&type=script&lang=js"
import style0 from "./acctInfoPwdModify.vue?vue&type=style&index=0&id=21b28965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b28965",
  null
  
)

export default component.exports